module.exports = __webpack_public_path__ + "static/media/approvedRed.d20dff32.svg";